import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'black-ui-button',
    templateUrl: './ui-button.component.html',
    styleUrls: ['./ui-button.component.css'],
    standalone: false
})
export class UiButtonComponent implements OnInit {
  constructor() {}

  @Input() innerText = '';

  ngOnInit(): void {}

}
